// extracted by mini-css-extract-plugin
export default {"container":"container__u2fJL","image":"image__QlScc"};